import { PhotoshopController } from "../../../../photoshopController.js";
import { ParametersWidget } from "./parameterWidget.js";
import * as noUiSlider from '../../../../../node_modules/nouislider';

declare global {
    interface HTMLElement {
        noUiSlider?: noUiSlider.API;
    }
}
export class ColorBalanceParameterWidget extends ParametersWidget {

    constructor(parent: HTMLElement, controller: PhotoshopController, operation: any) {
        super(parent, controller);
        this.operation = operation;
        this.parent.innerHTML = ColorBalanceParameterWidget.html();
        super.initEvent();

        const cbTonesElement = document.getElementById("cb-tones");
        if (cbTonesElement) {
            cbTonesElement.addEventListener("change", function (event) {
                this.cb_tonesOnChange(parseInt((event.currentTarget as HTMLSelectElement).value));
            }.bind(this));
        }

        const cbLuminosityInput = document.getElementById("cb-luminosity-input");
        if (cbLuminosityInput) {
            cbLuminosityInput.addEventListener("change", function (event) {
                this.cb_luminosity_inputOnChange((event.currentTarget as HTMLInputElement).checked);
            }.bind(this));
        }

        this.updateModel();
        this.initializeColorBalanceRange();
    }

    static html() {
        return super.header() + `
        <div id="colorBalance" style="display: none; padding: 10px;">
            <h4 class="center-align">Balance des couleurs</h4>
            <div class="col s12 divider"></div>
            <div class="col s12" style="text-align: center">
                <select id="cb-tones">
                    <option value="0">Tons foncés</option>
                    <option value="1">Tons moyens</option>
                    <option value="2">Tons clairs</option>
                </select>
            </div>
            <div class="col s9 no-padding left" style="margin-top: 10px;">
                <div class="left">Cyan</div>
                <div class="right">Rouge</div>
            </div>
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                <div class="col s9 no-padding">
                    <div id="cb-cr-range" class="col s12 row"></div>
                </div>
                <div class="col s3">
                    <input id="cb-cr-input" type="number">
                </div>
            </div>
            <div class="col s12 divider"></div>
            <div class="col s9 no-padding left" style="margin-top: 10px;">
                <div class="left">Magenta</div>
                <div class="right">Vert</div>
            </div>
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                <div class="col s9 no-padding">
                    <div id="cb-mv-range" class="col s12 row"></div>
                </div>
                <div class="col s3">
                    <input id="cb-mv-input" type="number">
                </div>
            </div>
            <div class="col s12 divider"></div>
            <div class="col s9 no-padding left" style="margin-top: 10px;">
                <div class="left">Jaune</div>
                <div class="right">Bleu</div>
            </div>
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                <div class="col s9 no-padding">
                    <div id="cb-jb-range" class="col s12 row"></div>
                </div>
                <div class="col s3">
                    <input id="cb-jb-input" type="number">
                </div>
            </div>
            <div class="col s12 no-padding">
                <p>
                    <label>
                        <input id="cb-luminosity-input" type="checkbox">
                        <span>Conserver la luminosité</span>
                    </label>
                </p>
            </div>
        </div>
        `+ super.footer();
    }

    cb_tonesOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.tone = value;
        this.initializeColorBalanceRange();
        this.photoshopController.update();
    }

    cb_cr_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.red = value;
        this.photoshopController.update();
    }

    cb_mv_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.green = value;
        this.photoshopController.update();
    }

    cb_jb_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.blue = value;
        this.photoshopController.update();
    }

    cb_luminosity_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.preserve_luminosity = value;
        this.photoshopController.update();
    }

    updateModel() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation) {
            if (this.photoshopController.PSEngine.activeOperation.tone !== undefined) {
                const cbTones = document.getElementById("cb-tones") as HTMLSelectElement | null;
                if (cbTones) {
                    cbTones.value = this.photoshopController.PSEngine.activeOperation.tone;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.red !== undefined) {
                const cbCrInput = document.getElementById("cb-cr-input") as HTMLInputElement | null;
                if (cbCrInput) {
                    cbCrInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.red;
                    cbCrInput.min = this.photoshopController.PSEngine.activeOperation.minRed;
                    cbCrInput.max = this.photoshopController.PSEngine.activeOperation.maxRed;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.green !== undefined) {
                const cbMvInput = document.getElementById("cb-mv-input") as HTMLInputElement | null;
                if (cbMvInput) {
                    cbMvInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.green;
                    cbMvInput.min = this.photoshopController.PSEngine.activeOperation.minGreen;
                    cbMvInput.max = this.photoshopController.PSEngine.activeOperation.maxGreen;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.green !== undefined) {
                const cbJbInput = document.getElementById("cb-jb-input") as HTMLInputElement | null;
                if (cbJbInput) {
                    cbJbInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.blue;
                    cbJbInput.min = this.photoshopController.PSEngine.activeOperation.minBlue;
                    cbJbInput.max = this.photoshopController.PSEngine.activeOperation.maxBlue;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.preserve_luminosity !== undefined) {
                const cbLuminosityInput = document.getElementById("cb-luminosity-input") as HTMLInputElement | null;
                if (cbLuminosityInput) {
                    cbLuminosityInput.checked = this.photoshopController.PSEngine.activeOperation.preserve_luminosity;
                }
            }
        }
    }

    updateIf() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        super.updateIf();
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'colorBalance') {
            const colorBalanceElement = document.getElementById("colorBalance");
            if (colorBalanceElement) {
                colorBalanceElement.style.display = "";
            }
        } else {
            const colorBalanceElement = document.getElementById("colorBalance");
            if (colorBalanceElement) {
                colorBalanceElement.style.display = "none";
            }
        }
    }

    initializeColorBalanceRange() {

        window.setTimeout(() => {
            if (!this.photoshopController.PSEngine) {
                return;
            }
            if (!this.photoshopController.PSEngine.activeOperation) {
                return;
            }
            var crRange = document.getElementById("cb-cr-range");
            if (crRange) {
                if (crRange.noUiSlider) {
                    crRange.noUiSlider.destroy();
                }
                noUiSlider.create(crRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.red],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minRed,
                        max: this.photoshopController.PSEngine.activeOperation.maxRed
                    }
                });
                if (crRange.noUiSlider) {
                    crRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.red = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const cbCrInput = document.getElementById('cb-cr-input');
                if (cbCrInput) {
                    cbCrInput.addEventListener('change', function (event) {
                        this.cb_cr_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (crRange && crRange.noUiSlider) {
                            crRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }

            var mvRange = document.getElementById("cb-mv-range");
            if (mvRange) {
                if (mvRange.noUiSlider) {
                    mvRange.noUiSlider.destroy();
                }
                noUiSlider.create(mvRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.green],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minGreen,
                        max: this.photoshopController.PSEngine.activeOperation.maxGreen
                    }
                });
                if (mvRange.noUiSlider) {
                    mvRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.green = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const cbMvInput = document.getElementById('cb-mv-input');
                if (cbMvInput) {
                    cbMvInput.addEventListener('change', function (event) {
                        this.cb_mv_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (mvRange && mvRange.noUiSlider) {
                            mvRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }

            var jbRange = document.getElementById("cb-jb-range");
            if (jbRange) {
                if (jbRange.noUiSlider) {
                    jbRange.noUiSlider.destroy();
                }
                noUiSlider.create(jbRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.blue],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minBlue,
                        max: this.photoshopController.PSEngine.activeOperation.maxBlue
                    }
                });
                if (jbRange.noUiSlider) {
                    jbRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.blue = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const cbJbInput = document.getElementById('cb-jb-input');
                if (cbJbInput) {
                    cbJbInput.addEventListener('change', function (event) {
                        this.cb_jb_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (jbRange && jbRange.noUiSlider) {
                            jbRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }
        });
    }

    reglages_undoOnClick() {
        super.reglages_undoOnClick();
        this.updateModel();
        this.updateIf();
        this.initializeColorBalanceRange();
    }
}